var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-list',_vm._l((_vm.activities),function(activity){return _c('activity',{key:activity,attrs:{"type":activity}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }